import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = ({ height = 100, width = '100%', style = {}, className = '' }) => (
  <div
    className={`shimmer-loading ${className}`}
    style={{ height, width, ...style }}
    data-testid="shimmer-loading"
  />
);

export default LoadingScreen;
